import type * as React from 'react';

function SvgMatchups(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <path
        d="M21 4H18V3C18 2.4478 17.5527 2 17 2C16.4473 2 16 2.4478 16 3V4H8V3C8 2.4478 7.5527 2 7 2C6.4473 2 6 2.4478 6 3V4H3C2.4473 4 2 4.4478 2 5V21C2 21.5522 2.4473 22 3 22H21C21.5527 22 22 21.5522 22 21V5C22 4.4478 21.5527 4 21 4ZM4 20V8H20V20H4Z"
        fill="currentColor"
      />
      <path
        d="M9.1523 11.2256C9.0371 11.3594 8.8652 11.4614 8.6367 11.5318C8.4062 11.6021 8.1055 11.6373 7.7344 11.6373V12.38H8.8946V17.2535H10.2266V10.7467H9.3536C9.3341 10.9327 9.2656 11.0923 9.1523 11.2256Z"
        fill="currentColor"
      />
      <path
        d="M11.4062 11.8267H14.8925C14.5038 12.3365 14.1679 12.8555 13.8886 13.3833C13.6074 13.9116 13.3749 14.4209 13.1894 14.9111C13.0058 15.4018 12.8652 15.8486 12.7695 16.2519C12.6738 16.6557 12.6133 16.9892 12.5898 17.2534H14.0078C14.0156 16.9565 14.0664 16.6206 14.1601 16.2456C14.2538 15.8706 14.3769 15.4795 14.5292 15.0732C14.6815 14.6665 14.8534 14.2631 15.0448 13.8628C15.2343 13.4624 15.4335 13.0864 15.6425 12.7354C15.8515 12.3844 16.0585 12.0816 16.2655 11.8267V10.7466H11.4061L11.4062 11.8267Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgMatchups;
